import { RealtimeMemberStatus } from '../../features/realtime/realtime.types';
import { type WaitingMember } from '../../shared/waitingMember';

/**
 * Anonymizes patient name during screen sharing.
 * Used for patients in the waiting room to protect privacy.
 */
export const anonymizeName = (fullName: string): string => {
  return fullName
    .split(' ')
    .map((part) => {
      if (part.length === 0) {
        return '';
      }
      const initial = part.charAt(0).toUpperCase();
      const stars = '*'.repeat(3);
      return `${initial}${stars}`;
    })
    .join(' ');
};

/**
 * Comparator for sorting users by their `joinedAt` property in ascending order,
 * placing users who joined earlier appear first.
 *
 * @example
 * ```ts
 * waitingMembers.sort(compareByJoinedAt);
 * ```
 */
export const compareByJoinedAt = (a: WaitingMember, b: WaitingMember): number =>
  a.joinedAt - b.joinedAt;

/**
 * Comparator for sorting users by their `state.status` property,
 * placing those with `RealtimeMemberStatus.OnHold` first.
 *
 * @example
 * ```ts
 * waitingMembers.sort(compareByOnHoldStatus);
 * ```
 */
export const compareByOnHoldStatus = (
  a: WaitingMember,
  b: WaitingMember,
): number => {
  const isAOnHold = a.state?.status === RealtimeMemberStatus.OnHold;
  const isBOnHold = b.state?.status === RealtimeMemberStatus.OnHold;

  return isAOnHold === isBOnHold ? 0 : isAOnHold ? -1 : 1;
};
